import { buildHowToSchema } from "@/lib/schemaBuilders";

/**
 * HowTo JSON-LD for the "read a peptide COA in 60 seconds" steps on
 * /how-to-read-a-peptide-coa. Passed to <BlogPost extraSchema={[...]}>. The
 * BlogPosting + FAQPage schema are emitted by BlogPost from the DB content;
 * this adds the HowTo that BlogPost doesn't derive on its own.
 */
export const COA_GUIDE_HOWTO_SCHEMA = buildHowToSchema({
  name: "How to read a peptide COA in 60 seconds",
  description:
    "A fast checklist for reading a peptide certificate of analysis: prioritize identity and dose, treat endotoxin and sterility as situational, and ignore badge counts.",
  totalTime: "PT1M",
  steps: [
    { name: "Find the identity result", text: "Confirm the mass spec result matches the labeled compound. No identity, no deal." },
    { name: "Find the quantification (dose)", text: "Look for actual milligrams measured, not just the number printed on the vial." },
    { name: "Check HPLC purity %", text: "Higher is better, but purity does not prove the amino-acid sequence, so it sits under identity." },
    { name: "Treat endotoxin and sterility as bonuses", text: "They matter mainly if you are injecting finished material." },
    { name: "Ignore the badge count", text: "\"7x tested / 20x tested\" is marketing, not proof. More panels does not mean a better vial." },
    { name: "Verify the lab", text: "A named, reputable testing lab and a batch-specific report beat a wall of green checkmarks." },
  ],
}) as Record<string, unknown>;
